import request from '@/utils/request'
import { getParameter } from '@/components/library/params'

/**
 * 获取全部事项
 */
export const findService = () => {
  return request('/webapi/apps/portal/service/Query', 'post', getParameter({ desc: true, pageSize: 10, orderBy: 'seqNo' }))
}

/**
 * 获取校区
 */
export const findRegion = () => {
  return request('/webapi/apps/portal/region/Query', 'post', getParameter({ desc: true, pageSize: 10, orderBy: 'seqNo' }))
}

/**
 * 获取服务部门
 */
export const findParty = () => {
  return request('/webapi/apps/portal/party/Query', 'post', getParameter({ desc: true, pageSize: 10, orderBy: 'seqNo' }))
}

/**
 * 获取服务类别
 */
export const findCategory = () => {
  return request('/webapi/apps/portal/category/Query', 'post', getParameter({ desc: true, pageSize: 10, orderBy: 'seqNo' }))
}

/**
 * 获取服务对象
 */
export const findGroup = () => {
  return request('/webapi/apps/portal/group/Query', 'post', getParameter({ desc: true, pageSize: 10, orderBy: 'seqNo' }))
}
